import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const ReportsPage = lazy(() => import('@/containers/Views/Reports/ReportsPage'));

const ReportsRouter = (
  <Route path="reports">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.Reports}
          permissions={EBasicActions.Find}
        >
          <ReportsPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default ReportsRouter;
